import SummaryCounter from './SummaryCounter';

export default SummaryCounter;
